export default __webpack_public_path__ + "static/media/PicnicCover.cef3f197.png";